// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609032241/js/" + chunkId + "." + {"44":"8897d282","225":"ef2ef403","481":"a99805f7","486":"2bc7cd15","770":"e3b814b8"}[chunkId] + ".0.35337443406073554.chunk.js";
};